import Cookies from 'js-cookie';

const TokenKey = 'qiuzi_hospital_admin_token';

export const getTokenCookie = () => {
  return Cookies.get(TokenKey);
};

export const setTokenCookie = (token: string) => {
  // return Cookies.set(TokenKey, token, { secure: true, sameSite: 'Lax' }); // TODO
  return Cookies.set(TokenKey, token);
};

export const removeTokenCookie = () => {
  return Cookies.remove(TokenKey);
};
